import { FILING_STATUS_LABELS, FILING_STATUS_HELP } from '../data/federal-2026';
import { FILING_STATUSES } from '../lib/schema';
import type { FilingStatus } from '../data/federal-2026';

interface FilingStatusStepProps {
  value: FilingStatus;
  onChange: (next: FilingStatus) => void;
}

export function FilingStatusStep({ value, onChange }: FilingStatusStepProps) {
  return (
    <fieldset className="space-y-3">
      <legend className="text-base font-medium text-slate-900">
        What is your filing status?
      </legend>
      <p className="text-sm text-slate-500">
        Pick the status you'll use when you file. This drives your standard
        deduction and tax brackets.
      </p>
      <div className="space-y-2">
        {FILING_STATUSES.map((status) => {
          const checked = value === status;
          return (
            <label
              key={status}
              className={`flex cursor-pointer items-start gap-3 rounded-lg border p-4 transition-colors ${
                checked
                  ? 'border-brand-500 bg-brand-50'
                  : 'border-slate-200 bg-white hover:border-slate-300'
              }`}
            >
              <input
                type="radio"
                name="filingStatus"
                value={status}
                checked={checked}
                onChange={() => onChange(status)}
                className="mt-1 h-4 w-4 cursor-pointer accent-brand-600"
              />
              <span>
                <span className="block text-sm font-medium text-slate-900">
                  {FILING_STATUS_LABELS[status]}
                </span>
                <span className="mt-1 block text-xs text-slate-500">
                  {FILING_STATUS_HELP[status]}
                </span>
              </span>
            </label>
          );
        })}
      </div>
    </fieldset>
  );
}